export default __webpack_public_path__ + "static/media/DSC_7340.c5611c68.jpg";